import { render, staticRenderFns } from "./MessageIn.vue?vue&type=template&id=58087640&scoped=true"
import script from "./MessageIn.vue?vue&type=script&lang=js"
export * from "./MessageIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58087640",
  null
  
)

export default component.exports